import { render, staticRenderFns } from "./video.vue?vue&type=template&id=b8fb733c&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"
import style0 from "./video.vue?vue&type=style&index=0&id=b8fb733c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fb733c",
  null
  
)

export default component.exports